




















































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Section from "@/models/section.model";
import ConfigProfileService from "@/services/configProfile.service";
import CiudadanoService from "@/services/ciudadano.service";
import ProfileAttribute from "../../models/profileAttribute.model";
import SourceService from "../../models/sourceService.model";
import MapProfileAttribute from "../../models/mapProfileAttribute.model";
import { Utils } from "@/core/Utils";
import ProfileSection from "./profileSection.vue";
import ConfigProfile from "../../models/configProfile.model";
import BaseVue from "@/core/BaseVue";
import NameValue from "@/models/nameValue.model";
import NameValueService from "@/services/nameValue.service";
import ConfigProfileSectionCondition from "@/models/configProfileSectionCondition.model";
import { ConditionType } from "@/enums/ConditionType";
import ProfileTabContainer from "./profileTabContainer.vue";
import ProfileChildComponentViewer from "./profileChildComponentViewer.vue";
import Helpers from '../../helpers/helper';
import {
  getSessionUserInfo,
  setSessionUserInfo
} from "@/helpers/sessionStorage";

@Component({
  name: "profile",
  components: {
    ProfileSection,
    ProfileTabContainer,
    ProfileChildComponentViewer
  }
})
export default class ProfileIndexComponent extends BaseVue {
  @Prop() public value!: any;
  @Prop() public isParentTab!: boolean;
  @Prop() public profile!: any;
  @Prop() public identifier!: any;

  c_isParentTab: boolean =
    this.isParentTab != undefined ? this.isParentTab : false;

  loadingBuscar = false;
  ciudadanoService: CiudadanoService = new CiudadanoService();
  activeChildSection: any = null;
  activeChildProfileInfo: any = null;
  sections: Array<any> = [];
  profileInfo: any = this.profile != undefined ? this.profile : null;
  firstSearch = true;
  configAndData: {
    config: ConfigProfile;
    data: any;
  } = {
    config: new ConfigProfile(),
    data: null
  };

  searchCriteria: string = this.identifier == undefined ? "" : this.identifier;
  loadingFake = false;
  nameValueService: NameValueService = new NameValueService();
  defaultService: NameValue = new NameValue();

  valuesOfCondition: any = [];
get isConsultaRapida(){
  return this.$route.path.toLowerCase().includes('profilequickreference');
}
  get isLoggedIn() {
    return this.$store.getters.isLoggedIn;
  }

  validateCiudadanoServiceAttributeRequest(ids: any) {
    // Consulta rápida temporalmente desactivada.
    // return this.isLoggedIn
    //   ? this.ciudadanoService.getCiudadanoInfoByAttributeIds(
    //       this.identifier,
    //       ids
    //     )
    //   : this.ciudadanoService.getCiudadanoInfoByAttributeIdsWithoutAuth(
    //       this.identifier,
    //       ids
    //     );
    return this.ciudadanoService.getCiudadanoInfoByAttributeIds(
      this.identifier,
      ids
    );
  }

  visibleCondition(section: Section) {
    if (section.configProfileSectionConditions.length) {
      var ids = section.configProfileSectionConditions.map(
        x => x.attributeId
      ) as Array<number>;

      this.validateCiudadanoServiceAttributeRequest(ids).then(data => {
        for (
          let i = 0;
          i < section.configProfileSectionConditions.length;
          i++
        ) {
          const condition = section.configProfileSectionConditions[i];
          if (condition && condition.attribute && condition.attributeId) {
            var valor = data[condition.attributeId];
            var valor2 = null;

            switch (condition.attribute.dataType.codigo) {
              case "CONFIG_PROFILE_FIELD_DATA_TYPE_NUMBER": {
                valor2 = condition.valorInt;
                break;
              }
              case "CONFIG_PROFILE_FIELD_DATA_TYPE_TEXT": {
                valor2 = condition.valorString;
                break;
              }
              case "CONFIG_PROFILE_FIELD_DATA_TYPE_BOOL": {
                valor2 = condition.valorBooleano;
                break;
              }
              case "CONFIG_PROFILE_FIELD_DATA_TYPE_DATE": {
                valor2 = condition.valorDate;
                break;
              }
              default: {
                valor2 = condition.valorString;
              }
            }

            if (condition.conditionType == ConditionType.VISIBILIDAD) {
              section.visible = this.makeOperation(condition, valor, valor2);
            }

            this.valuesOfCondition[condition.attributeId];
          }

          if (!section.visible) break;
        }
        //this.$forceUpdate();
      });
    }
    return true;
  }
  makeOperation(
    condition: ConfigProfileSectionCondition,
    valor: any,
    valor2: any
  ) {
    if (condition.operator) {
      if (condition.operator.codigo == "CONDITION_OPERATOR_MAYOR_IGUAL") {
        return valor >= valor2;
      } else if (
        condition.operator.codigo == "CONDITION_OPERATOR_MENOR_IGUAL"
      ) {
        return valor <= valor2;
      } else if (condition.operator.codigo == "CONDITION_OPERATOR_MENOR") {
        return valor < valor2;
      } else if (condition.operator.codigo == "CONDITION_OPERATOR_MAYOR") {
        return valor > valor2;
      } else if (condition.operator.codigo == "CONDITION_OPERATOR_DIFFERENT") {
        return valor != valor2;
      } else if (condition.operator.codigo == "CONDITION_OPERATOR_EQUAL") {
        return valor == valor2;
      }
    }

    return true;
  }
  get isMobile() {
    return this.$store.state.isMobile;
  }
  get visibleSections() {
    let array = this.sections.filter(x => x.visible);
    if (this.isLoggedIn) {
      if (this.isMobile)
        return array
          .filter(x => x.psOnlineMovil);
      return array
        .filter(x => x.psOnline);
    } else {
      if (this.isMobile)
        return array
          .filter(x => !x.isAuthenticationRequired)
          .filter(x => x.psOnlineMovil);
      return array
        .filter(x => !x.isAuthenticationRequired)
        .filter(x => x.psOnline);
    }
    // return this.isLoggedIn
    //   ? this.sections.filter(x => x.visible && (this.isMobile ? x.psOnlineMovil : x.psOnline))
    //   : this.sections.filter(x => x.visible && !x.isAuthenticationRequired && (this.isMobile ? x.psOnlineMovil : x.psOnline));
  }
  get user() {
    return this.$store.state.user;
  }
get cedula(){
  return this.$route.params.cedula.replace('-','');
}
  async search() {
    // Consulta rápida temporalmente desactivada.
    // if (this.$route.params.cedula && !this.isLoggedIn) {
    //   this.loadingBuscar = true;
    //   var cacheInfo = false;
    //   this.loadingFake = true;
    //   this.user.cedula = this.cedula;
    //
    //   if (!cacheInfo) {
    //     this.loadingFake = false;
    //     this.configAndData = (await this.ciudadanoService.syncCiudadanoWithoutAuth(
    //       this.cedula
    //     )) as any;
    //     localStorage.setItem("userInfo", JSON.stringify(this.configAndData));
    //     localStorage.setItem("consultaRapida", this.cedula);
    //   } else {
    //     setTimeout(() => {
    //       this.loadingFake = false;
    //     }, 2000);
    //   }
    //
    //   this.sections = this.configAndData.config.sections;
    //   this.profileInfo = this.configAndData.data;
    //   this.loadingBuscar = false;
    //   return;
    // }
    if (this.firstSearch) {
      this.loadingBuscar = true;
      this.firstSearch = false;
      var cacheInfo = true;
      var info = getSessionUserInfo<any>(null);
      this.loadingFake = true;

      if (info) {
        if (info.cedula == this.user.cedula) {
          await this.ciudadanoService
            .needRefresh(this.user.cedula)
            .then(needRefresh => {
              if (!needRefresh) {
                this.configAndData = info;
              } else {
                cacheInfo = false;
              }
            });
        } else {
          cacheInfo = false;
        }
      } else {
        cacheInfo = false;
      }

      if (!cacheInfo) {
        this.loadingFake = false;
        this.configAndData = (await this.ciudadanoService.syncCiudadano(
          this.user.cedula
        )) as any;
        setSessionUserInfo(this.configAndData);
      } else {
        setTimeout(() => {
          this.loadingFake = false;
        }, 2000);
      }

      this.sections = this.configAndData.config.sections;
      this.profileInfo = this.configAndData.data;
      this.loadingBuscar = false;
    }
  }
  setActiveChildSection(section: any, profileInfo: any) {
    this.$emit("setActiveChild", {
      section: section,
      profileInfo: profileInfo
    });
  }
  onSetActiveChild(childInfo: any) {
    this.activeChildSection = childInfo.section;
    this.activeChildProfileInfo = childInfo.profileInfo;
  }
  onChildGoBack() {
    this.activeChildSection = null;
  }

  mounted() {
    if (this.isMobile) {
      this.$store.dispatch("mobileShowNavbarInMobile", false);
    } else {
      this.$store.dispatch("mobileShowNavbarInMobile", true);
    }
    // if (this.isLoggedIn) {

    // } else {
    //   if (this.isMobile) {
    //     this.$store.dispatch("mobileShowSectionLogout", true);
    //   } else {
    //     this.$store.dispatch("mobileShowSectionLogout", false);
    //   }

    //   this.$store.dispatch("mobileShowNavbarInMobile", false);
    // }
    if (this.value) {
      this.sections = this.value;
    } else {
      this.search();
    }
  }
}
